<template>
  <div>
    <div class="mb-4 flex justify-content-between align-items-center">
      <span v-if="id > 0" class="pr-2 mr-2 font-bold text-2xl"
        >Sales Order - Edit</span
      >
      <span v-else class="pr-2 mr-2 font-bold text-2xl"
        >Sales Order - Tambah</span
      >
      <div>
        <i class="pi pi-home mr-2"></i>
        <span v-if="id > 0" class="font-small"
          >/ Penjualan / Sales Order / Edit</span
        >
        <span v-else class="font-small"
          >/ Penjualan / Sales Order / Tambah</span
        >
      </div>
    </div>
    <form-sales-order :id="id" />
  </div>
</template>

<script>
import FormSalesOrder from '@/components/penjualan/FormSalesOrder'

export default {
  components: {
    FormSalesOrder,
  },
  data() {
    return {
      id: parseInt(this.$route.params.id),
    }
  },
}
</script>
